import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import useContentFeed from '../../common/use-content-feed';

import Feed from '../../components/feed';

import { trackSearchSuccess, trackSearchError } from '../../models/analytics';
import { SearchResults } from './search';
import { DEFAULT_SKIP_TO_CONTENT_ID } from '../../components/skip-to-content/skip-to-content';

const SearchPosts = ({ term }) => {
  const { fetching, page, feedItems, error, canLoadMore, total, fetchFeed } =
    useContentFeed({ query: term });

  const analyticsData = {
    location: 'search_posts',
    searchType: 'contents',
    searchTerm: term,
  };

  useEffect(() => {
    if (!error) {
      // track success
      trackSearchSuccess(analyticsData);
    } else {
      // track error
      trackSearchError({ ...analyticsData, error });
    }
  }, [term, error]);

  const { t } = useTranslation();

  return (
    <section className="search-content" id={DEFAULT_SKIP_TO_CONTENT_ID}>
      {!fetching && total ? (
        <div className="search-component__header">
          <SearchResults count={total} />
        </div>
      ) : null}
      <div className="container container--slim">
        {!error ? (
          <Feed
            items={feedItems}
            page={page}
            fetching={fetching}
            canLoadMore={canLoadMore}
            fetchFeed={fetchFeed}
            analyticsData={analyticsData}
          />
        ) : (
          <div className="container">
            {t('assistant.error_searching_content', { term })}
          </div>
        )}
      </div>
      {!fetching && total == 0 ? (
        <div className="search-component__footer">
          <SearchResults count={total} />
        </div>
      ) : null}
    </section>
  );
};

export default SearchPosts;
